module.exports = __webpack_public_path__ + "3e54687a295f35c31af2b7155745d4fd.png";


//////////////////
// WEBPACK FOOTER
// ./assets/imgs/Spotin_SymbolS_Square_Off_White_Big_RGB.png
// module id = 167
// module chunks = 0